var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 2C4.25 1.58579 4.58579 1.25 5 1.25H19C19.4142 1.25 19.75 1.58579 19.75 2C19.75 2.41421 19.4142 2.75 19 2.75H18V8.26015C18 8.73757 17.8292 9.19925 17.5185 9.56173L15.4286 12L17.5185 14.4383C17.8292 14.8008 18 15.2624 18 15.7398V21.25H19C19.4142 21.25 19.75 21.5858 19.75 22C19.75 22.4142 19.4142 22.75 19 22.75H5C4.58579 22.75 4.25 22.4142 4.25 22C4.25 21.5858 4.58579 21.25 5 21.25H6V15.7398C6 15.2624 6.17078 14.8008 6.48149 14.4383L8.57143 12L6.48149 9.56174C6.17078 9.19925 6 8.73757 6 8.26015V2.75H5C4.58579 2.75 4.25 2.41421 4.25 2ZM9.27881 20H14.7212C15.7409 20 16.349 18.9724 15.7834 18.2052L13.0622 14.5141C12.5569 13.8286 11.4431 13.8286 10.9378 14.5141L8.21656 18.2052C7.65095 18.9724 8.25915 20 9.27881 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassAlt);
export default __webpack_public_path__ + "static/media/hourglass-alt.5ce017e3b4cede67112d81407200a3c9.svg";
export { ForwardRef as ReactComponent };